import React from 'react';
import {
  WORKFLOW_LANES,
  type WorkflowLane,
  workflowLaneHint,
  workflowLaneLabel,
} from '../constants/complianceWorkflowGuardrails';

type LegendProps = {
  language: 'en' | 'es';
  kind?: string;
  selected?: readonly WorkflowLane[];
  onToggle?: (lane: WorkflowLane) => void;
};

export const WorkflowLaneChip: React.FC<{ lane: WorkflowLane; language: 'en' | 'es' }> = ({
  lane,
  language,
}) => (
  <em className={`compliance-workflow-chip is-${lane} is-on`}>
    {workflowLaneLabel(lane, language)}
  </em>
);

const ComplianceWorkflowLegend: React.FC<LegendProps> = ({
  language,
  kind,
  selected,
  onToggle,
}) => (
  <div
    className="compliance-workflow-legend"
    role="group"
    aria-label={language === 'es' ? 'Filtrar pasos' : 'Filter steps'}
  >
    {WORKFLOW_LANES.map((lane) => {
      const on = !selected || selected.includes(lane);
      const label = workflowLaneLabel(lane, language);
      const hint = workflowLaneHint(lane, language, kind);
      if (!onToggle) {
        return (
          <span key={lane} className={`compliance-workflow-legend-item is-${lane}`}>
            <strong className={`compliance-workflow-chip is-${lane} is-on`}>
              {label}
            </strong>
            <span>{hint}</span>
          </span>
        );
      }
      return (
        <button
          key={lane}
          type="button"
          className={`compliance-workflow-chip is-${lane}${on ? ' is-on' : ''}`}
          aria-pressed={on}
          aria-label={language === 'es'
            ? `${label}. ${hint}. ${on ? 'Visible' : 'Oculto'}`
            : `${label}. ${hint}. ${on ? 'Showing' : 'Hidden'}`}
          onClick={() => onToggle(lane)}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default ComplianceWorkflowLegend;
